import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useParams, useLocation } from "react-router-dom";
import { MediaPipeProvider } from "./contexts/MediaPipeContext.jsx";
import AdminLogin from "./pages/LoginPage.jsx";
import AnalyseResume from "./components/shared_components/AnalyseResume.jsx";
import InterviewPortal from "./pages/Candidate Pages/Interviews/TechnicalInterviewPortal.jsx";
import LiveAvatarFullModePortal from "./pages/Candidate Pages/Interviews/LiveAvatarFullModePortal.jsx";
import ThankYou from "./pages/Candidate Pages/ThanksPage.jsx";
import SecondaryCameraThanksPage from "./components/SecondaryCamera/SecondaryCameraThanksPage.jsx";
import BulkResumeUpload from "./components/hrportal/BulkResumeParser.jsx";
import MCQTest from "./pages/Candidate Pages/MCQTestPage.jsx";
import BehavioralTest from "./pages/Candidate Pages/BehavioralTestPage.jsx";
import TestHomePage from "./pages/Candidate Pages/testHomePage.jsx";
import MCQInstructions from "./components/Instructions/MCQInstructions.jsx";
import BehavioralInstructions from "./components/Instructions/BehavioralInstructions.jsx";
import CodingInstructions from "./components/Instructions/CodingInstructions.jsx";
import InterviewInstructions from "./components/Instructions/InterviewInstructions.jsx";
import TypingTestInstructions from "./components/Instructions/TypingTestInstructions.jsx";
import CodingProblemsPage from "./pages/Candidate Pages/CodingProblemsPage.jsx";
import TypingTest from "./pages/Candidate Pages/TypingTest.jsx";
import NotFound from "./pages/NotFound.jsx";
import OrgAdminPortal from "./components/orgadmin/OrgAdminPortal.jsx";
import HRPortal from "./components/hrportal/HRPortal.jsx";
import RoleRedirect from "./pages/RoleRedirect.jsx";
import HrProfile from "./components/orgadmin/HRProfiles.jsx";
import CreatedJDs from "./components/shared_components/ViewCreatedJDs.jsx";
import CreateMCQSet from "./components/orgadmin/CreateMCQSet.jsx";
import MCQSetsLibrary from "./components/orgadmin/mcq/MCQSetsLibrary.jsx";
import CreateBehavioralSet from "./components/orgadmin/CreateBehavioralSet.jsx";
import BehavioralSetsLibrary from "./components/orgadmin/behavioral/BehavioralSetsLibrary.jsx";
import AIGenerateFlow from "./components/orgadmin/mcq/AIGenerateFlow.jsx";
import BehavioralAIGenerateFlow from "./components/orgadmin/behavioral/ai/AIGenerateFlow.jsx";
import Fetch from "./components/orgadmin/fetchmcq.jsx";
import GenieHirePortal from "./components/geniehireadmin/GenieHireAdminDash.jsx";
import AccLvlDash from "./components/geniehireadmin/AccLvlDash.jsx";
import CreateCodingProblemSet from "./components/orgadmin/CreateCodingProblemSet.jsx";
import BulkResumeSummary from "./components/hrportal/BulkResumeSummary.jsx";
import OrgAdminEditProfile from "./components/orgadmin/OrgAdminEditProfile.jsx";
import HREditProfile from "./components/hrportal/HREditProfile.jsx";
import ScheduleTest from "./pages/Candidate Pages/ScheduleTest.jsx";
import HRDashBoard from "./components/hrportal/Dashboard.jsx";
import JobVacancies from "./components/hrportal/JobVacancies.jsx";
import CandidateReports from "./components/shared_components/CandidateReports.jsx";
import EvaluationReport from "./components/shared_components/EvaluationReport.jsx";
import OrgAdminDashBoard from "./components/orgadmin/Dashboard.jsx";
import CreateJDCustomView from "./components/orgadmin/Jobs/CreateJDCustomView.jsx";
import CandidatePortal from "./pages/Candidate Pages/CandidatePortal.jsx";
import CandidateAnalytics from "./components/orgadmin/CandidateAnalytics.jsx";
import Feedback from "./components/geniehireadmin/Feedback.jsx";
import MicHealthTracker from "./components/geniehireadmin/MicHealthTracker.jsx";
// import GenieHireDashboard from "./components/geniehireadmin/Dashboard.jsx";
import JobInterestSurvey from "./pages/Candidate Pages/JobInterestSurvey.jsx";
import GenieHireForm from "./pages/Candidate Pages/GenieHireForm.jsx";
import CandidateList from "./components/orgadmin/Candidatelist.jsx";
import CandidateDashboard from "./pages/CandidateDashboard.jsx";
import CandidateProfileEdit from "./pages/CandidateProfileEdit.jsx";
import CandidateLogin from "./pages/CandidateLogin.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import ConfigurationData from "./components/orgadmin/ConfigurationData.jsx";
import TestLibrary from "./components/orgadmin/Testlibrary.jsx";
import EditJobDescription from "./components/shared_components/EditJobDescription.jsx";
import InterviewEvaluationReport from "./components/Reports/InterviewResult.jsx";
import TypingTestReport from "./components/Reports/TypingTestResult.jsx";
import PublicReport from "./components/Reports/PublicReport.jsx";
import OrgAdminBulkResumeUpload from "./components/orgadmin/OrgAdminBulkResumeUpload.jsx";
import OrgAdminBulkResumeSummary from "./components/orgadmin/OrgAdminBulkResumeSummary.jsx";
import CreateJDSmartView from "./components/orgadmin/Jobs/CreateJDSmartView.jsx";
import JDOverviewPage from "./components/orgadmin/Jobs/SharedJDOverviewPage.jsx";
import JDSelectionPage from "./components/orgadmin/JDSelectionPage.jsx";
import BulkActivity from "./components/shared_components/BulkActivity.jsx";
import ATSFormDispatcher from "./pages/Candidate Pages/ATSFormDispatcher.jsx";
import JobDescriptionViewer from "./pages/Candidate Pages/JobDescriptionViewer.jsx";
import GrievanceForm from "./components/shared_components/GrievanceForm.jsx";
import CareersPage from "./pages/Organization/CareersPage.jsx";
// import PublicJobApplication from "./pages/Candidate Pages/tmp.jsx"
import SourcedCandidates from "./components/orgadmin/SourcedCandidates.jsx";
import JobApplicants from "./components/hrportal/JobApplicants.jsx";
import SecondaryCamera from "./components/SecondaryCamera/SecondaryCamera.jsx";
import { getWhiteLabelFromInterview } from "./utils/whitelabel.js";
import CandidateManagement from "./pages/CandidateManagement.jsx";
import CandidateFormPage from "./pages/Candidate Pages/CandidateFormPage.jsx";
import { useDispatch } from "react-redux";
import { updateNavigationTab } from "./store/slices/candidateManagementSlice.js";
import Sourcing from "./sourcing/components/Sourcing.jsx";
import Projects from "./sourcing/components/projects/Projects.jsx";
import ProjectDetail from "./sourcing/components/projects/ProjectDetail.jsx";
import ContactedCandidates from "./sourcing/components/projects/ContactedCandidates.jsx";
import SourcingResults from "./sourcing/components/SourcingResults.jsx";
import SourcingPreview from "./sourcing/components/SourcingPreview.jsx";
import Shortlist from "./sourcing/components/Shortlist.jsx";
// The shared_components copy is the one with Razorpay checkout; the orgadmin copy
// is display-only and never had an entry point.
import SubscriptionUsage from "./components/shared_components/SubscriptionUsage.jsx";
import SavedCandidates from "./sourcing/components/SavedCandidates.jsx";
import EditCompanyProfile from "./components/orgadmin/EditCompanyProfile.jsx";
import SequenceManager from "./sourcing/components/sequencing/SequenceManager.jsx";
import SequenceBuilder from "./sourcing/components/sequencing/builder/SequenceBuilder.jsx";
import TemplateManager from "./sourcing/components/sequencing/TemplateManager.jsx";
import EntryPoint from "./sourcing/components/EntryPoint.jsx";
import ScreeningResponses from "./sourcing/components/screening/ScreeningResponses.jsx";
import ScreeningFormPage from "./sourcing/components/screening/ScreeningFormPage.jsx";
import EmailTracker from "./sourcing/components/sequencing/EmailTracker.jsx";
import CallTracker from "./sourcing/components/sequencing/CallTracker.jsx";
import EmailSettings from "./sourcing/components/EmailSettings.jsx";
import RequireSourcing from "./sourcing/components/RequireSourcing.jsx";
import FindCandidates from "./pages/FindCandidates.jsx";
import SelectJobRole from "./pages/SelectJobRole.jsx";
// import RecruitmentPerformanceDashboard from "./components/orgadmin/RecruitmentPerformanceDashboard.jsx";
import RaiseTicketPage from "./components/orgadmin/RaiseTicketPage.jsx";
import TutorialVideosPage from "./components/orgadmin/TutorialVideosPage.jsx";
import RecruiterAnalytics from "./components/orgadmin/RecruiterAnalytics.jsx";
import MobileNotSupported, { isMobileDevice, isMobileAllowedPath } from "./components/common/DesktopOnlyGate.jsx";
import { leaveSignupTracking } from "./utils/adTracking";

const IS_MOBILE_DEVICE = isMobileDevice();

const App = () => {
  const [isWhiteLabelingEnable, setisWhiteLabelingEnable] = useState(false);
  const [isFetched, setIsFetched] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const loadStatus = async () => {
      const url = new URL(window.location.href);
      const pathSegments = url.pathname.split("/");
      const id = pathSegments[2];
      console.log(id);
      const branding = await getWhiteLabelFromInterview(id);
      if(branding && branding.whitelabelEnabled){
        setisWhiteLabelingEnable(branding.whitelabelEnabled)
        // console.log({APP_JSX_whitelabelEnabled:branding.whitelabelEnabled})
        localStorage.setItem("isWhite",branding.whitelabelEnabled)
      }
    };
    if(!isFetched){
      console.log("Called API Here Dont Call Again")
      loadStatus();
      setIsFetched(true);
    }
  }, []);

  useEffect(() => {
    const path = location.pathname;

    // The signup page's Meta Pixel and Clarity must not follow into the app
    leaveSignupTracking(path);

    // Check both cases
    if (path === '/org-admin/dashboard' || path === '/dashboard' || path === "/hr/dashboard") {
      dispatch(updateNavigationTab('ALL'));
    }
  }, [location.pathname, dispatch]);

  // The UI is desktop-only; phones and tablets get a notice instead of a broken layout.
  if (IS_MOBILE_DEVICE && !isMobileAllowedPath(location.pathname)) {
    return <MobileNotSupported />;
  }

  return (

    <MediaPipeProvider>
     
        <Routes>
          <Route path="/hr/*" element={<HRPortal />}>
            <Route path="dashboard" element={<HRDashBoard />} />
            {/* Temp Rpoute for Testing Dont Push To Prod */}
            <Route path="candidatereports" element={<CandidateReports />} />
            <Route path="jobs/:jobRole" element={<CandidateManagement />} />
            <Route path="schedule-interview" element={<CandidateManagement />} />
            <Route path="candidate-management" element={<CandidateManagement />} />
            <Route path="jobvacancies" element={<CreatedJDs />} />
            <Route path="hreditprofile" element={<HREditProfile />} />
            <Route path="checkresume" element={<AnalyseResume />} />
            <Route path="BulkResume" element={<BulkResumeUpload />} />
            <Route
              path="BulkResume/Bulkresumemodel/:upload_id"
              element={<BulkResumeSummary />}
            />
            <Route
              path="evaluationpage/:interview_id"
              element={<EvaluationReport />}
            />
            <Route
              path="interview-report/:interview_id"
              element={<InterviewEvaluationReport />}
            />
            <Route
              path="typing-test-result/:interview_id"
              element={<TypingTestReport />}
            />
            <Route path="job-applicants" element={<JobApplicants />} />
            <Route path="activity" element={<BulkActivity />} />
            <Route path="editjd" element={<EditJobDescription />} />
            <Route path="create-jd-custom" element={<CreateJDCustomView />} />
            <Route path="create-jd-smart" element={<CreateJDSmartView />} />
            <Route path="jd-overview" element={<JDOverviewPage />} />
          </Route>

          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<NotFound />} />

          {/* Landing Page Routes  */}
          {/* The keys make switching between / and /signup open the page
              afresh; without them React keeps it, and the form shown would
              not follow the address (e.g. on Back). */}
          <Route path="/" element={<AdminLogin key="login" />} />
          {/* Self-serve onboarding. The marketing site's "Start Free Trial"
              links here; same page as login, opened on the wizard. */}
          <Route path="/signup" element={<AdminLogin key="signup" initialMode="signupStart" />} />
          <Route path="/role-redirect" element={<RoleRedirect />} />

          {/* GenieHire Admin Routes  */}
          <Route path="/geniehireadmin/*" element={<GenieHirePortal />}>
            <Route path="dashboard" element={<GenieHirePortal />} />
            <Route path="requestdemo" element={<GenieHirePortal />} />
            <Route path="organisation" element={<GenieHirePortal />} />
            <Route path="organisation/:organisation" element={<AccLvlDash />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="mic-health" element={<MicHealthTracker />} />
            <Route path="impersonate" element={<GenieHirePortal />} />
            <Route path="support-inbox" element={<GenieHirePortal />} />
            <Route path="candidate-feedback" element={<GenieHirePortal />} />
          </Route>

          {/* Organization Admin Routes  */}
          <Route path="/org-admin/*" element={<OrgAdminPortal />}>
            <Route path="dashboard" element={<OrgAdminDashBoard />} />
            <Route path="recruiter-analytics" element={<RecruiterAnalytics />} />
            <Route path="hrprofiles" element={<HrProfile />} />
            <Route path="candidatereports" element={<CandidateReports />} />
            {/* Usage: what the plan grants, what is left of it, and the
                plans available to upgrade to. Reached from the sidebar and
                from Upgrade Now on the dashboard. */}
            <Route path="usage" element={<SubscriptionUsage />} />
            {/* Kept so older links and bookmarks still land somewhere. */}
            <Route path="plans" element={<SubscriptionUsage />} />
            {/* Temp changing Page for Dev Purpose */}
             <Route path="candidateanalytics" element={<CandidateAnalytics />} />
             {/* Sourcing & Outreach routes are gated on the org's sourcing_enabled flag */}
             <Route element={<RequireSourcing />}>
              {/* Pick the job role first — every list on Find Candidates is scoped to one. */}
              <Route path="find-candidates" element={<SelectJobRole />} />
              <Route path="find-candidates/:jobId" element={<FindCandidates />} />
              <Route path="sourcing" element={<Sourcing />} />
              <Route path="sourcing/projects" element={<Projects />} />
              <Route path="sourcing/projects/:projectId" element={<ProjectDetail />} />
              <Route path="sourcing/contacted" element={<ContactedCandidates />} />
              <Route path="sourcing/results" element={<SourcingResults />} />
              <Route path="sourcing/shortlist" element={<Shortlist />} />
              <Route path="sourcing/saved" element={<SavedCandidates />} />
              <Route path="sourcing/sequences" element={<SequenceManager />} />
              <Route path="sourcing/sequences/new" element={<SequenceBuilder />} />
              <Route path="sourcing/sequences/edit/:id" element={<SequenceBuilder />} />
              <Route path="sourcing/templates" element={<TemplateManager />} />
              <Route path="sourcing/entrypoint" element={<EntryPoint />} />
              <Route path="sourcing/screening-responses" element={<ScreeningResponses />} />
              <Route path="sourcing/emailtracker" element={<EmailTracker />} />
              <Route path="sourcing/calltracker" element={<CallTracker />} />
              <Route path="sourcing/emailsettings" element={<EmailSettings />} />
              <Route path="sourcing/preview" element={<SourcingPreview />} />
             </Route>
              <Route path="jobs/:jobRole" element={<CandidateManagement />} />
              <Route path="schedule-interview" element={<CandidateManagement />} />
              <Route path="candidate-management" element={<CandidateManagement />} />
            <Route path="checkresume" element={<AnalyseResume />} />
           
            <Route path="created-jds" element={<CreatedJDs />} />
            <Route path="create-jd-smart" element={<CreateJDSmartView />} />
            <Route path="create-jd-custom" element={<CreateJDCustomView />} />
            <Route path="jd-overview" element={<JDOverviewPage />} />
            <Route path="jd-selection" element={<JDSelectionPage />} />{" "}
            {/* ✅ Fixed */}
            <Route path="jobvacancies" element={<JobVacancies />} />
            <Route path="editprofile" element={<OrgAdminEditProfile />} />
            <Route path="edit-company-profile" element={<EditCompanyProfile />} />
            <Route element={<RequireSourcing />}>
              <Route path="find-candidates" element={<SelectJobRole />} />
              <Route path="find-candidates/:jobId" element={<FindCandidates />} />
              <Route path="sourcing" element={<Sourcing />} />
              {/* The search flow is Sourcing → preview → Find Candidates, so HR needs
                  the preview step too or its Search button dead-ends. */}
              <Route path="sourcing/preview" element={<SourcingPreview />} />
              <Route path="sourcing/results" element={<SourcingResults />} />
            </Route>
            <Route path="fetchmcq" element={<Fetch />} />
            <Route
              path="evaluationpage/:interview_id"
              element={<EvaluationReport />}
            />
            <Route path="testlibrary" element={<TestLibrary />} />
            {/* Static segments before :setId so /mcqsets/new and /mcqsets/ai are
                never read as a set id. */}
            <Route path="mcqsets" element={<MCQSetsLibrary />} />
            <Route path="mcqsets/new" element={<CreateMCQSet />} />
            <Route path="mcqsets/ai" element={<AIGenerateFlow />} />
            <Route path="mcqsets/:setId" element={<CreateMCQSet />} />
            {/* Superseded by the library; kept so existing links still land. */}
            <Route path="createmcqset" element={<Navigate to="/org-admin/mcqsets" replace />} />
            <Route path="behavioralsets" element={<BehavioralSetsLibrary />} />
            <Route path="behavioralsets/new" element={<CreateBehavioralSet />} />
            <Route path="behavioralsets/ai" element={<BehavioralAIGenerateFlow />} />
            <Route path="behavioralsets/:setId" element={<CreateBehavioralSet />} />
            <Route
              path="createcodingproblemset"
              element={<CreateCodingProblemSet />}
            />
            <Route path="candidatelist" element={<CandidateList />} />
            <Route path="configurations" element={<ConfigurationData />} />
            <Route path="editjd" element={<EditJobDescription />} />
            <Route path="BulkResume" element={<OrgAdminBulkResumeUpload />} />
            <Route
              path="BulkResume/Bulkresumemodel/:upload_id"
              element={<OrgAdminBulkResumeSummary />}
            />
            <Route
              path="interview-report/:interview_id"
              element={<InterviewEvaluationReport />}
            />
            <Route path="activity" element={<BulkActivity />} />
            <Route path="sourced-candidates" element={<SourcedCandidates />} />
            <Route path="job-applicants" element={<JobApplicants />} />
            {/* <Route path="recruitment-performance" element={<RecruitmentPerformanceDashboard />} /> */}
            <Route path="raise-ticket" element={<RaiseTicketPage />} />
            <Route path="tutorial-videos" element={<TutorialVideosPage />} />

          </Route>

          <Route path="/candidate/*" element={<CandidatePortal  />}>
            <Route
              path=":interview_id/scheduletest"
              element={<ScheduleTest />}
            />
            <Route
              path=":interview_id/testhomepage"
              element={<TestHomePage/>}
            />
            <Route
              path=":interview_id/mcqinstructions"
              element={<MCQInstructions />}
            />
            <Route path="mcqtest/:interview_id" element={<MCQTest />} />
            <Route
              path=":interview_id/behavioralinstructions"
              element={<BehavioralInstructions />}
            />
            <Route path="behavioraltest/:interview_id" element={<BehavioralTest />} />
            <Route
              path=":interview_id/codinginstructions"
              element={<CodingInstructions />}
            />
            <Route
              path="codingtest/:interview_id"
              element={<CodingProblemsPage />}
            />
            <Route
              path=":interview_id/typingtestinstructions"
              element={<TypingTestInstructions />}
            />
            <Route
              path="typingtest/:interview_id"
              element={<TypingTest />}
            />
            <Route
              path=":interview_id/interviewinstructions"
              element={<InterviewInstructions />}
            />
            <Route
              path="interview/:interview_id"
              element={<InterviewPortal />}
            />
            <Route
              path="live-avatar-interview/:interview_id"
              element={<LiveAvatarFullModePortal />}
            />
            <Route
              path=":interview_id/candidate-form"
              element={<CandidateFormPage />}
            />
          </Route>
          {/* User Routes  */}
          <Route path="/GenieHireForm" element={<GenieHireForm />} />
          <Route path="/thankyou/:interview_id" element={<ThankYou />} />
          <Route
            path="/jobinterestsurvey/:job_id/:candidate_id"
            element={<JobInterestSurvey />}
          />
          <Route path="/candidate-login" element={<CandidateLogin />}></Route>
          <Route
            path="/candidate-dashboard"
            element={<CandidateDashboard />}
          ></Route>
          <Route
            path="/candidate-edit-profile"
            element={<CandidateProfileEdit />}
          ></Route>
          <Route path="/candidate-reset-password" element={<ResetPassword />} />
          {/* Public Job Application Page */}
          <Route path="/apply/:linkToken" element={<ATSFormDispatcher />} />
          {/* Public Candidate Screening Form */}
          <Route path="/screening/:token" element={<ScreeningFormPage />} />
          {/* View Job Description Only */}
          <Route path="/overview/:linkToken" element={<JobDescriptionViewer />} />
          {/* Proxy Link URL Page */}
          <Route
            path="/shared-interview-report/:token"
            element={<PublicReport />}
          />
          {/* Secondary Camera Route */}
          <Route
            path="/secondary-camera/:token"
            element={<SecondaryCamera />}
          />
          {/* Secondary Camera Thank You Page */}
          <Route
            path="/secondary-camera-thankyou/:interview_id"
            element={<SecondaryCameraThanksPage />}
          />

          {/* Grievance Form Page */}
          <Route path="/grievance-form" element={<GrievanceForm />} />

          {/* Public Careers Page */}
          <Route path="/careers/:organizationId" element={<CareersPage />} />
        </Routes>

    </MediaPipeProvider>
  );
};

export default App;
